import React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import ResponsePurchaseModal from "../../pages/trivia/Components/ResponsePurchaseModal";
import * as actionCreators from "../../modules/actions"
import InviteAdminsTrivvy from "../../pages/office/InviteOfficeMates/InviteAdminsTrivvy";
import { withRouter } from "react-router";


 function GreyOutUpgradePlanuBlockUi({ children,orgChangeSuccess,history,buttonText }) {
    const [openResponseModal,setOpenResponseModal] = useState(false)
  return (
    <div style={{ position: "relative" }}>
        {
            openResponseModal && <InviteAdminsTrivvy  orgChangeSuccess={orgChangeSuccess} history={history} open={openResponseModal} onClose={()=> setOpenResponseModal(false) } />
        }
      <div className="grey-out-back-ui">{children}</div>

      <div className="button_over_grey_ui">
        <Button
          size="sm"
          className="trivia-action-button-main button-center-absolute"
          onClick={()=>setOpenResponseModal(true)}
          style={{height:"auto"}}
        >
          {buttonText||"Upgrade Plan"}
        </Button>
      </div>
    </div>
  );
}


const mapStateToProps = state => {
    return {
     
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      orgChangeSuccess: data => dispatch(actionCreators.orgChangeSuccess(data)),
     
    };
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GreyOutUpgradePlanuBlockUi));
